var React = require('react');

function IconArchive (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"A simple black and white icon of a file box with lid and handle."),React.createElement("path",{"d":"M19.429 14.857q0-0.464-0.339-0.804t-0.804-0.339h-4.571q-0.464 0-0.804 0.339t-0.339 0.804 0.339 0.804 0.804 0.339h4.571q0.464 0 0.804-0.339t0.339-0.804zM29.714 11.429v17.143q0 0.464-0.339 0.804t-0.804 0.339h-25.143q-0.464 0-0.804-0.339t-0.339-0.804v-17.143q0-0.464 0.339-0.804t0.804-0.339h25.143q0.464 0 0.804 0.339t0.339 0.804zM30.857 3.429v4.571q0 0.464-0.339 0.804t-0.804 0.339h-27.429q-0.464 0-0.804-0.339t-0.339-0.804v-4.571q0-0.464 0.339-0.804t0.804-0.339h27.429q0.464 0 0.804 0.339t0.339 0.804z","key":1})]);
}

IconArchive.defaultProps = {"className":"icon icon-bottom","version":"1.1","width":"20","height":"20","viewBox":"0 0 35 35"};

module.exports = IconArchive;

IconArchive.default = IconArchive;
